import { render, staticRenderFns } from "./keteranganHapus.vue?vue&type=template&id=912cd45e"
import script from "./keteranganHapus.vue?vue&type=script&lang=js"
export * from "./keteranganHapus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports